import { useMemo, useState } from 'react';

export default function useOpenInvoiceSorting(invoices) {
    const [sort, setSort] = useState({ field: 'dueDate', direction: 'asc' });

    const toggleSort = (field) => {
        setSort((prev) => {
            if (prev.field === field) {
                return { field, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            }
            return { field, direction: 'asc' };
        });
    };

    const sortedInvoices = useMemo(() => {
        const data = [...invoices];
        const { field, direction } = sort;
        const multiplier = direction === 'asc' ? 1 : -1;
        const getValue = (inv) => {
            switch (field) {
                case 'invoiceNumber':
                    return inv.invoiceNumber || '';
                case 'customerName':
                    return inv.customerName || '';
                case 'invoiceDate':
                    return inv.invoiceDate ? new Date(inv.invoiceDate).getTime() : Number.MIN_SAFE_INTEGER;
                case 'outstandingAmount':
                    return Number(inv.outstandingAmount ?? 0);
                case 'daysOverdue':
                    return Number(inv.daysOverdue ?? 0);
                case 'dueDate':
                    return inv.dueDate ? new Date(inv.dueDate).getTime() : Number.MAX_SAFE_INTEGER;
                default:
                    return inv[field] || '';
            }
        };
        data.sort((a, b) => {
            const valueA = getValue(a);
            const valueB = getValue(b);
            if (valueA === valueB) return 0;
            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return valueA > valueB ? multiplier : -multiplier;
            }
            return valueA > valueB ? multiplier : -multiplier;
        });
        return data;
    }, [invoices, sort]);

    return { sort, toggleSort, sortedInvoices };
}
